module.exports = __webpack_public_path__ + "static/media/tier-6.01d1a301.jpg";